import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import conveyorBoxClient from "../../conveyorbox/ConveyorBoxClient";
import { reducerComposite, RootState, store } from "../storeConfig";
import { resetAppState } from "../shared/actions";
import { ICancelledItemUI } from "../../interfaces/ConveyorBox/IConveyorBox";
// import { BOX_CANCELLATION_ERRORS } from "constants/constants";
// import { triggerDispenseItemCancelledStage } from "state/globalSlice";
// import { RootState } from "state/store";
// import { onAxiosResponse } from "utils/axios";
// import { logger } from "utils/sessionActionLogger";
// import { resetAppState } from "../shared/actions";
// import { setBox } from "./boxSlice";

// types & interfaces

export interface ICancelledItemRestockRequest {
  itemId: number;
  scannedQuantity: number;
  missingQuantity: number;
  operatorAssignedShelf: string;
  deliveryId: number;
}

export interface ICancelledItemRestockResponse {
  deliveryId: number;
  requestedShelf: string;
  suggestedShelf: string | null;
  isValid: boolean;
}

export interface CancelledItemsState {
  items: ICancelledItemUI[];
  activeDeliveryId: number;
  scannedItemId: ICancelledItemUI["id"] | null;
  isLoading: boolean;
  error: string | null;
}

// initial state
const initialState: CancelledItemsState = {
  items: [],
  activeDeliveryId: -1,
  scannedItemId: null,
  isLoading: false,
  error: null,
};

const cancelledItemsSlice = createSlice({
  name: "cancelledItems",
  initialState,
  reducers: {
    setCancelledItems: (state, action: PayloadAction<ICancelledItemUI[]>) => {
      state.items = action.payload;
    },

    upsertCancelledItem: (state, action: PayloadAction<ICancelledItemUI>) => {
      const idx = state.items.findIndex((i) => i.id === action.payload.id);

      if (idx === -1) {
        state.items.push(action.payload);

        // if it’s fully verified on insert, mark scannedItemId
        if (action.payload.cancelledQuantityVerified === action.payload.cancelledQuantity) {
          state.scannedItemId = action.payload.id;
        }
        return;
      }

      state.items[idx] = action.payload;

      if (action.payload.cancelledQuantityVerified === action.payload.cancelledQuantity) {
        state.scannedItemId = action.payload.id;
      }
    },

    removeCancelledItem: (state, action: PayloadAction<number>) => {
      state.items = state.items.filter((i) => i.id !== action.payload);
    },

    clearCancelledItems: (state) => {
      state.items = [];
      state.scannedItemId = null;
      state.activeDeliveryId = -1;
      state.error = null;
      state.isLoading = false;
    },

    setScannedItemId: (state, action: PayloadAction<number | null>) => {
      state.scannedItemId = action.payload;
    },

    setActiveDeliveryId: (state, action: PayloadAction<number>) => {
      state.activeDeliveryId = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(resetAppState, () => initialState);
  },
});

export const {
  setCancelledItems,
  upsertCancelledItem,
  removeCancelledItem,
  clearCancelledItems,
  setScannedItemId,
  setActiveDeliveryId,
} = cancelledItemsSlice.actions;

export const cancelledItemsStateSelector = (s: RootState) => s.cancelledItemReducer;
export const cancelledItemsSelector = (s: RootState) => s.cancelledItemReducer.items;
export const scannedItemIdSelector = (s: RootState) => s.cancelledItemReducer.scannedItemId;

export default cancelledItemsSlice.reducer;
